import { SUPPORTED_CULTURES } from '@/utils/constants'

/**
 * Generate hreflang meta tag
 * @param {object} route
 * @param {object} router
 */

const metaHreflang = (
  route,
  router,
  country = null) => {
  const ignoredRoutes = ['HelpCategory', 'HelpArticle']
  if (ignoredRoutes.includes(route.meta.key)) {
    return []
  }
  const alternatives = [
  ]
  const supportedLanguages = SUPPORTED_CULTURES.map(
    culture => culture.twoLetter
  )
  supportedLanguages.forEach((key) => {
    const req = {
      key: route.meta.key,
      ...(country && { params: { country } })
    }
    const resolvedRoute = router.resolveLocalRoute(
      req,
      key
    )
    if (key === 'en') {
      alternatives.push(
        {
          hid: 'default-alternate',
          rel: 'alternate',
          hreflang: 'x-default',
          href: process.env.websiteUrl + resolvedRoute.href
        }
      )
      alternatives.push(
        {
          hid: 'en-alternate',
          rel: 'alternate',
          hreflang: 'en',
          href: process.env.websiteUrl + resolvedRoute.href
        }
      )
    } else {
      alternatives.push(
        {
          hid: 'es-alternate',
          rel: 'alternate',
          hreflang: key,
          href: process.env.websiteUrl + resolvedRoute.href
        }
      )
    }
  })
  return alternatives
}

export { metaHreflang }
